import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import ViewRealtorParticipationStep from "../../../../../../../shared/wizard/steps/viewRealtorParticipationStep";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import { EDealRequestViewType } from "../../../../../../../shared/wizard/steps/types";

interface IWishStepBuy_3 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishStepBuy_3 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IWishStepBuy_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.buy.step_2);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.wishesSteps.buy.step_4);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="buy"
      />
    </div>
  );
};

export default WishStepBuy_3;
